export interface Product {
    id: string
    idProductGroup: string
    idImage: string
    idImages: string[]
    idMealType: string
    idPrinters: string[]
    type: number
    reference: string
    name: string
    description: string
    otherLanguages: productOtherLanguage[]
    prices: Price[]
    bongText: string
    isAddon: boolean
    isDish: boolean
    isMotd: boolean // Meal of the day
    isMotw: boolean // Meal of the week
    isTip: boolean
    isSotd: boolean // Stock of the day
    isStock: boolean
    stockLevel: number // Future function
    active: boolean
    sortorder: number
    addons: ProductAddon[]
    localAddons: Addon[]
    blockedTo: string
    idAllergies: string[]
    remoteId: string // Used in product integration
    remoteQuantity: number
    noDiscount: boolean
    unit: string
    linkedProducts: LinkedProduct[]
}

export interface ProductAddon {
    idAddon: string
    displayOrder: number
    active: boolean
    sortorder: number
}

export interface productOtherLanguage {
    languageCode: string
    name: string
    description: string
    sortorder: number
}

export interface LinkedProduct {
    id: string
    idProduct: string
    overridePrice: number
    quantity: number
    forwardMode: ForwardMode
    free: boolean
    sortorder: number
}

export enum ForwardMode {
    none = 0,
    forward = 1,
    wait = 2
}

export interface Price {
    idPriceList: string
    priceIncl: number
    ordPriceIncl: number
    sortorder: number
}

export interface ProductGroup {
    id: string
    idVat: string
    name: string
    account: string
    sortorder: number
}

export interface Vat {
    id: string
    name: string
    vatPercent: number
    default: boolean
    sortorder: number
}

export interface Addon {
    id: string
    name: string
    displayName: string
    otherLanguages: AddonOtherLanguage[]
    freeItems: number
    minItems: number
    maxItems: number
    multi: boolean // Multi select addons
    //group: boolean // Group addons on print
    hidden: boolean // Hidden addons to be printed on bong
    active: boolean
    sortorder: number
    displayOrder: number
    products: AddonProduct[]
}

export interface AddonProduct {
    id: string
    idProduct: string
    overridePrice: number
    free: boolean
    default: boolean
    defaultAmount: number
    useParentPrinter: boolean
    active: true
}

export interface AddonOtherLanguage {
    languageCode: string
    name: string
    displayName: string
    sortorder: number
}

export interface MealType {
    id: string
    name: string
    sortorder: number
}

export interface Discount {
    id: string
    name: string
    amount: number
    type: DiscountType,
    mode: DiscountMode,
    rules: DiscountRule[]
    ruleDefaultAllow: boolean
    idCalendar: string
    active: boolean
    sortorder: number
} 

export enum DiscountType {
    percentage = 0,
    amount = 1,
    pricelist = 2
}

export enum DiscountMode {
    cart = 0,
    row = 1
}

export interface DiscountRule {
    id: string
    field: string // ex: idProduct or idProductGroup
    comparison: string // eq or ne
    value: string
    allowDiscount: boolean
    amount: number
    active: boolean
}